import React, { Component, Fragment } from 'react';
import Papa from "papaparse";
import { Map, List, Record } from 'immutable';
import axios from 'axios';
import {
  Table,
  Container, Row, InputGroupText, InputGroup, Col, Button, Form, FormText,
  FormGroup, Label, Input,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import HeaderComponent from '../header/HeaderComponent'



function statusChange(type) {
  const { data } = this.state;
  this.setState(
    { data: data.set("currentSlamState", type) }
  );
}


class CSVImport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      customer_name: "charan",
      user_id: "",

      height: 1536,
      width: 1536,


      project_name: "mtest",

      totalPartNum: 0,
      currentPartnum: 0,

      product_id: "",
      category1: "top",
      category2: "blouse",

      showPreviewModal: false,
      csvStats: null,
      uploading: false,
    }
    statusChange = statusChange.bind(this);

    this.test = React.createRef()
  }




  onValueChanged = (name, value) => {
    let obj = {};
    obj[name] = value;
    this.setState(obj);
  }
  async componentDidMount() {
    const { data } = this.state;
    function decodeJwtResponse(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    };
    // this.setState(
    //     { data: data.set("email", decodeJwtResponse(this.props.cognito.user.signInUserSession.idToken.jwtToken).email) }
    // )
    // console.log(this.props.cognito.user.signInUserSession.idToken.jwtToken)
    // console.log(decodeJwtResponse(this.props.cognito.user.signInUserSession.idToken.jwtToken).email)

  }

  handleFileChange = (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    this.setState({ files: files });

    function extractInsideCurlyBrackets(input) {
      if (input == undefined) return null;
      const regex = /\{([^}]+)\}/;
      const match = input.match(regex);
      return match ? match[1] : null;
    }

    Papa.parse(files[0], {
      header: true,
      complete: (results) => {
        const data = results.data;
        const columns = results.meta.fields || [];

        let skippedNoUrl = 0;
        let skippedIncomplete = 0;
        let validRows = 0;
        const noUrlIds = [];
        const incompleteIds = [];
        const sizeErrorIds = [];

        for (const row of data) {
          const product_id = row["id"];
          const project_name = row["project"];
          const category_1 = row["category"];
          const url = row["url"];

          // rows with no product_id are treated as non-existent
          if (!product_id) continue;

          // mirror the first skip condition in handleCsvUpload
          if (!url) {
            skippedNoUrl++;
            noUrlIds.push(product_id);
            continue;
          }

          // attempt sizes parse, same as handleCsvUpload
          try {
            const str = row["sizes"] ? row["sizes"].replaceAll('\'', '"') : null;
            if (str) {
              const _sizeInfo = JSON.parse(str);
              void _sizeInfo[category_1];
            }
          } catch (_) {
            sizeErrorIds.push(product_id);
          }

          // mirror the inclusion condition in handleCsvUpload
          if (product_id && project_name && url) {
            validRows++;
          } else {
            skippedIncomplete++;
            incompleteIds.push(product_id);
          }
        }

        this.setState({
          csvStats: {
            totalRows: data.length,
            validRows,
            skippedNoUrl,
            skippedIncomplete,
            noUrlIds,
            incompleteIds,
            sizeErrorIds,
            columns,
          },
          showPreviewModal: true,
        });
      },
      error: (error) => {
        console.error("Error parsing CSV file:", error);
      },
    });
  };

  handleCsvUpload = async () => {

    function extractInsideCurlyBrackets(input) {
      if (input == undefined) {
        return null;
      }
      // Use regular expression to match content inside curly brackets
      const regex = /\{([^}]+)\}/;
      const match = input.match(regex);

      // If a match is found, return the content; otherwise, return null
      return match ? match[1] : null;
    }

    const csvFile = this.state.files[0];

    if (!this.state.customer_name || this.state.customer_name.length < 1) {
      alert("고객사 이름을 입력해주세요");
      return;
    }
    Papa.parse(csvFile, {
      header: true, // If your CSV has headers
      complete: async (results) => {
        const data = results.data;
        let totalParts = data.length;
        this.setState({ totalPartNum: totalParts });

        let cnt = 0;
        let arr = [];
        for (const row of data) {
          const product_id = row["id"];
          const project_name = row["project"];
          const category_1 = row["category"];
          const url = row["url"];
          if (!url) {
            continue;
          }
          let hip = undefined
          let waist = undefined
          let breast = undefined
          let sleeve = undefined
          let shoulder = undefined
          let total = undefined
          try {
            const str = row["sizes"] ? row["sizes"].replaceAll('\'', '"') : null;
            console.log(product_id);
            console.log(str);
            if (str) {
              const _sizeInfo = JSON.parse(str);
              const sizeInfo = _sizeInfo[category_1]
              if (sizeInfo != undefined) {
                hip = sizeInfo["hip"];
                waist = sizeInfo["waist"];
                breast = sizeInfo["breast"];
                sleeve = sizeInfo["sleeve"];
                shoulder = sizeInfo["shoulder"];
                total = sizeInfo["total"];
              }
            }
          } catch (parseError) {
            console.warn(`Failed to parse sizes for product_id ${product_id}:`, parseError);
          }
          const sizeGroup = extractInsideCurlyBrackets(row["dp_size_groups"])
          if (product_id && project_name && url) {
            arr.push({
              product_id, project_name, category_1, url,

              size_hip: hip,
              size_waist: waist,
              size_breast: breast,
              size_sleeve: sleeve,
              size_shoulder: shoulder,
              size_total: total,
              size_group: sizeGroup,

            })
          }
          try {
            this.setState({ currentPartnum: cnt++ });
          } catch (error) {
            console.error(`Failed to upload file from ${url}:`, error);
          }
        }
        this.setState({ uploading: true });
        axios({
          method: "Put",
          url: `${process.env.REACT_APP_CSV_PUTLARGE_PATH}`,
          timeout: 120000,
          headers: {
            // Every authenticated call attaches the Cognito idToken; the upload
            // PUT previously omitted it, so the JWT authorizer 401'd it.
            Authorization: this.props.cognito.user.signInUserSession.idToken.jwtToken,
          },
          data: {
            customer_name: this.state.customer_name,
            input_data: JSON.stringify(arr),
          },
        }).then((res) => {
          const imported = res && res.data && res.data.imported;
          alert(imported != null ? `CSV 파일 업로드 완료 (${imported}건)` : "CSV 파일 업로드 완료");
        }).catch((e) => {
          console.error("업로드 실패", e);
          alert("업로드에 실패했어요. 잠시 후 다시 시도해주세요.");
        }).finally(() => {
          // finally guarantees the "uploading" spinner always clears, even if
          // the request throws before settling.
          this.setState({ uploading: false });
        });

      },
      error: (error) => {
        console.error("Error parsing CSV file:", error);
      },
    });
  };
  render() {


    return (
      <Fragment>
        <HeaderComponent signOut={this.props.cognito.signOut} setStage={this.props.setStage} stage={this.props.stage}></HeaderComponent>
        <div className="main_contents">
          <Container fluid>
            <Row>
              <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                CSV 업로드입니다. 프로젝트 명,product_id,파일명 등은 CSV파일을 참고합니다.
              </div>


              <div className="col-md-12" id="time_c1">
                <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>

                  <Form className="col-md-6">
                    <FormGroup row>
                      <Label
                        for="exampleFile"
                        sm={2}
                      >
                        File
                      </Label>
                      <Col sm={10}>
                        <Input
                          id="exampleFile"
                          name="file"
                          type="file"
                          onChange={this.handleFileChange}
                        />
                        <FormText>
                          이미지 파일을 올려주세요
                        </FormText>
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      <Label
                        for="exampleEmail"
                        sm={2}
                      >
                        고개사 이름(영문)
                      </Label>
                      <Col sm={10}>
                        <Input

                          type="text"
                          disabled={true}
                          className="form-control"
                          placeholder="customer_name"
                          value={this.state.customer_name}
                          onChange={(val) => {
                            this.onValueChanged("customer_name", val.target.value);
                          }}
                        />
                      </Col>
                    </FormGroup>







                  </Form>

                </div>

              </div>
              <div>{this.state.uploading && (
                <a style={{ fontWeight: 800, color: "red" }}>업로드중...</a>
              )}</div>
              <div className="x_panel" style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
                <button type="submit" className="btn btn-primary" onClick={() => { this.handleCsvUpload() }}>
                  업로드
                </button>

              </div>

            </Row>
          </Container>
        </div>

        <Modal isOpen={this.state.showPreviewModal} toggle={() => this.setState({ showPreviewModal: false })}>
          <ModalHeader toggle={() => this.setState({ showPreviewModal: false })}>CSV 파일 확인</ModalHeader>
          <ModalBody>
            {this.state.csvStats && (() => {
              const { totalRows, validRows, skippedNoUrl, skippedIncomplete, noUrlIds, incompleteIds, sizeErrorIds, columns } = this.state.csvStats;
              return (
                <div>
                  <p><strong>전체 행 수:</strong> {totalRows}</p>
                  <p><strong>업로드 대상 행 수:</strong> {validRows}</p>

                  {skippedNoUrl > 0 && (
                    <>
                      <p><strong>건너뜀 (url 없음):</strong> {skippedNoUrl}</p>
                      <p style={{ color: 'red', fontSize: 12, marginTop: -10 }}>
                        ID: {noUrlIds.join(', ')}
                      </p>
                    </>
                  )}

                  {skippedIncomplete > 0 && (
                    <>
                      <p><strong>건너뜀 (id 또는 project 없음):</strong> {skippedIncomplete}</p>
                      <p style={{ color: 'red', fontSize: 12, marginTop: -10 }}>
                        ID: {incompleteIds.join(', ')}
                      </p>
                    </>
                  )}

                  {sizeErrorIds.length > 0 && (
                    <>
                      <p style={{ color: 'orange' }}><strong>sizes 파싱 오류:</strong> {sizeErrorIds.length}개 행 (업로드는 진행되나 사이즈 정보 누락)</p>
                      <p style={{ color: 'orange', fontSize: 12, marginTop: -10 }}>
                        ID: {sizeErrorIds.join(', ')}
                      </p>
                    </>
                  )}

                  <p><strong>컬럼 목록:</strong> {columns.join(', ')}</p>
                  <p style={{ color: 'gray', fontSize: 12 }}>※ id, project, url이 모두 있는 항목만 업로드됩니다.</p>
                </div>
              );
            })()}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => { this.setState({ showPreviewModal: false }); this.handleCsvUpload(); }}>
              업로드 시작
            </Button>
            <Button color="secondary" onClick={() => this.setState({ showPreviewModal: false })}>
              취소
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment >
    );
  }
}

export default CSVImport;
